module.exports = __webpack_public_path__ + "@/assets/img/iphone_no_clock.1d0e95f2.png";